import { render, staticRenderFns } from "./SettingsDrawer.vue?vue&type=template&id=2e7222a4&"
import script from "./SettingsDrawer.vue?vue&type=script&lang=js&"
export * from "./SettingsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7222a4')) {
      api.createRecord('2e7222a4', component.options)
    } else {
      api.reload('2e7222a4', component.options)
    }
    module.hot.accept("./SettingsDrawer.vue?vue&type=template&id=2e7222a4&", function () {
      api.rerender('2e7222a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/SettingsDrawer.vue"
export default component.exports